import { textToMarkdown } from "../common/utils/react-utils";

/**
 * Feature Flag service management for UI
 */
class FeatureService {
    private _context: Record<string, any> = {};

    initialize(context: Record<string, any> = {}) {
        // store context
        this._context = context;
    }

    // Returns the context record
    get context() {
        return this._context;
    }

    /**
     * Returns Public Website Link
     * @returns
     */
    getPublicWebsiteUrl() {
        return this._context.publicWebsiteUrl || "";
    }

    /**
     * Returns Snowflake Contact Us Link
     * @returns
     */
    getSnowflakeContactUrl() {
        return this._context.snowflake_contact_url || "";
    }

    /**
     * Returns Snowflake Support Link
     * @returns
     */
    getSnowflakeSupportUrl() {
        return this._context.snowflake_support_url || "";
    }

    /**
     * Returns AMC redirect URI
     * @returns
     */
    getAmcRedirectUri() {
        return this._context.amcRedirectUri || "";
    }

    /**
     * Returns AMC redirect URI
     * @returns
     */
    getAmcAuthUrl() {
        return this._context.amcAuthUrl || "";
    }

    /**
     * Returns AMC Auth Scope
     * @returns
     */
    getAmcAuthScope() {
        return this._context.amcAuthScope || "";
    }

    /**
     * Returns Privacy Policy Url
     * @returns
     */
    getPrivacyPolicyUrl() {
        return this._context.privacy_policy_url || "";
    }

    /**
     * Returns Privacy Column Policy Url
     * @returns
     */
    getPrivacyColumnPolicyUrl() {
        return this._context.privacy_column_policy_url || "";
    }

    /**
     * Returns Terms of Service Url
     * @returns
     */
    getTermsOfServiceUrl() {
        return this._context.terms_of_service_url || "";
    }

    /**
     * Returns Managed Account Terms of Service Url
     * @returns
     */
    getManagedAccountTermsOfServiceUrl() {
        return this._context.managed_account_terms_of_service_url || "";
    }

    /**
     * Returns AMC Client ID
     * @returns
     */
    getAmcClientId() {
        return this._context.amcClientId || "";
    }

    /**
     * Returns support text with URL in markdown format eg: [Support](https://www.snowflake.com)
     * @returns
     */
    getDCRSupportURLTextInMarkdown() {
        return textToMarkdown(this._context.dcrSupportUrlTextInMarkdown || "");
    }

    /**
     * Returns DCR support URL
     * @returns
     */
    getDCRSupportURL() {
        return this._context.dcrSupportUrl || "";
    }

    /**
     * Returns sales email
     * @returns
     */
    getSalesEmail() {
        return this._context.samoohaSalesEmailAddress || "";
    }

    /**
     * Returns engineering email
     * @returns
     */
    getEngineeringEmail() {
        return this._context.triageSamoohaEmailAddress || "";
    }

    getDeploymentsByCSP() {
        return this._context.deploymentsByCSP || {};
    }

    getIsOrgManagedAccount() {
        return this._context.org_is_managed_account || false;
    }

    getTTDDataCenters() {
        return this._context.ttdDataCenters || [];
    }

    getTTDCrmDataCenters() {
        return this._context.ttdCrmDataCenters || [];
    }
    getAnalysisListRefreshInterval() {
        return (
            this._context.analysis_list_refresh_interval_in_seconds * 1000 ||
            10000
        );
    }
    getManagedAccountCreditSuspendCutoffMonthly() {
        return this._context.managed_acct_credit_suspend_cutoff_monthly || 0;
    }
}

const FeatureServiceInstance = new FeatureService();

export default FeatureServiceInstance;
